const DEMANDE_LOGISTIQUE = {
  title: 'Demandes logistiques',
  titleIntervention: 'Demandes d\'intervention',
  titleImpression: 'Demandes d\'impression',
  messageMultiAction: 'Attention une des demandes logistiques est sur la même semaine que l\'affichage de la vente',
  tooltip: {
    accesCatalogue: 'Aucune action logistique possible sur un produit non relié a un patrimoine',
    displayAffectation: 'Voir affectation(s) liée(s) : {nb}',
    displayAffectationAutreCommande: 'Voir les affectations du produit en dehors de cette commande',
    displayDemandes: 'Voir demande(s) d\'intervention liée(s) : {nb}',
    displayDemandesImpressions: 'Voir demande(s) d\'impression liée(s) : {nb}',
    addDemande: 'Créer une demande logistique manuelle',
    addDemandeImpression: 'Créer une demande d\'impression',
    otTechCreate: 'Créer un OT technique',
    viewOtTechnique: 'Voir OT(s) technique(s) lié(s) : {nb}',
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette demande logistique?',
    message: 'Attention, l\'affectation logistique peut être impacté par cette suppression. N\'oubliez pas de regénérer vos affectations si besoin.',
    success: 'La demande a bien été supprimée',
  },
  table: {
    actionLogistique: 'Action à réaliser',
    datePlanification: 'Date de réalisation',
    typeDemande: 'Type de demande',
    typeOt: 'Type d\'OT technique',
    etat: 'Etat',
    ordreRealisation: 'Ordre',
    demandeur: 'Demandeur',
    source: 'Source',
    otTechniqueId: 'OT lié',
  },
  tableImpression: {
    dateDemande: 'Date demande',
    etat: 'Etat',
    client: 'Client',
    contactDemandeur: 'Contact demandeur',
    codeDispositif: 'Code dispositif',
    typesMateriels: 'Type de matériel',
    adresseDispositif: 'Adresse dispositif',
    campagne: 'Campagne',
    soldeStock: 'Solde stock',
    action: {
      deleteForbidden: 'Un OT est lié à cette demande d\'impression',
    },
  },
  creationOrUpdate: {
    action: 'Créer des demandes logistiques',
    titleCreate: 'Création demande logistique',
    titleUpdate: 'Modification de demande logistique',
    titleCreateIntervention: 'Création demande d\'intervention',
    titleUpdateIntervention: 'Modification de demande d\'intervention',
    actionLogistique: 'Action à réaliser',
    ordreDemandeIntervention: 'Ordre',
    datePlanification: 'Date de réalisation',
    successMulti: 'Les demandes ont bien été enregistré',
    success: 'La demande a bien été enregistrée',
    createAffichage: 'Créer la demande',
    updateAffichage: 'Modifier la demande',
    typeIntervention: 'Type d\'intervention',
    demandeur: 'Demandeur',
    typeOt: 'Type d\'OT technique',
    goToDemande: 'Aller sur la demande',
    typeDemande: 'Type de demande',
    patrimoine: 'Patrimoine',
    tab: {
      informations: 'Informations',
      faces: 'Sélection faces {nbrFacesSelected}',
    },
    error: {
      demandeUpdate: 'Modification de la Demande d\'intervention impossible.',
    },
  },
  patrimoine: {
    title: 'Demande logistique en cours',
    create: 'Demande logistique',
    see: 'Demande en cours',
    face: 'Face : {code}',
    materiel: 'Matériel : {code}',
    dispositif: 'Dispositif : {code}',
    emplacement: 'Emplacement : {code}',
    format: 'Format',
    demande: 'Action à réaliser',
    date: 'Date de réalisation',
    etat: 'Etat',
    typeDemande: 'Type demande',
    typeMateriel: 'Type matériel',
    dispositifSupport: 'Support',
    dispositifType: 'Type dispositif',
    etatDemande: {
      affectee: 'Affectée',
      affecteePatriellement: 'Affectée partiellement',
      nonAffectee: 'Non affectée',
    },
    aucuneDemande: 'Aucune demande n\'a été saisie',
    afficherAncienne: 'Afficher les anciennes demandes',
  },
};

export default DEMANDE_LOGISTIQUE;
